<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-autocomplete
                      label="Package Number *"
                      item-text="name"
                      item-value="id"
                      v-model="formSchema.package_no"
                      :items="assetPackage"
                      @change="setPackageCode"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                    <input type="hidden" v-model="formSchema.package_code" />
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'purchase_date', fieldValue:formSchema.purchase_date, label:'Purchase Date *', required:1}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-text-field
                      label="Purchase Price *"
                      v-model="formSchema.purchase_price"
                      :rules="[rules.decimalOnly]"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <v-autocomplete
                      label="Asset Item *"
                      item-text="item_name"
                      item-value="id"
                      v-model="formSchema.item_id"
                      :items="assetNames"
                      :rules="[v => !!v || 'Field is required']"
                      :disabled="disabled"
                      @change="changeAssetCodeField"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md6 class="pr-4">
                    <v-text-field
                      label="Asset Code *"
                      v-model="formSchema.asset_code"
                      disabled="disabled"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-autocomplete
                      label="Asset Status"
                      item-text="title"
                      item-value="id"
                      v-model="formSchema.asset_status"
                      :items="assetStatus"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-autocomplete
                      label="Asset Location"
                      item-text="location_name"
                      item-value="id"
                      v-model="formSchema.asset_location"
                      :items="assetLocation"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field label="Measurement Unit" v-model="formSchema.unit_name" disabled></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Quantity"
                      v-model="formSchema.quantity"
                      :rules="[rules.decimalOnly]"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>
                {{ buttonTitle }}
              </v-btn>
              
              <v-btn
                class="info"
                flat
                @click.native="close({message:'Form Reseted !',status:1,action:''})"
              >
                <v-icon>refresh</v-icon>Reset
              </v-btn>
              
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");
import DatePicker from "../../global/date_picker";

export default {
  components: {
    DatePicker
  },

  props: ["formSchema"],

  data: () => ({
    show: false,
    valid: true,
    assetSubCats: [],
    assetLocation: [],
    assetPackage: [],
    assetNames: [],
    assetCode:'',
    queryData:[],
    assetStatus: [],

    // asset status collection
    rules: {
      decimalOnly: value => {
        const pattern = /^\d+(\.\d)?\d*$/;
        return pattern.test(value) || "Not a valied number";
      }
    }
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0 ? "Edit Asset Master" : "Add Asset Master";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    disabled: function (val) {
      return (this.formSchema.id > 0 ) ? true : false;
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {
    this.loadData();

    let root = this;
    commonService.getAllData("get-role-list").then(res => {
      root.roleList = res.roleList;
    });
    // Asset Location List
    commonService.getAllData("get_asset_location_info").then(res => {
      root.assetLocation = res.data;
    });
    // Asset Package List
    commonService.getAllData("get_package_info").then(res => {
      root.assetPackage = res.data;
    });
    // Asset Name List
    commonService.getAllData("get_asset_item_info").then(res => {
      root.assetNames = res.data;
    });
    // get_asset_status Name List
    commonService.getAllData("get_asset_status").then(res => {
      root.assetStatus = res.data;
    });
  },

  

  methods: {
    validateBeforeSubmit(e) {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;

      formSchema.purchase_date = root.changeFormateYMD(
        this.formSchema.purchase_date
      );

      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "asset_master")
            .then(res => {
              res.action = "edit";
              this.close(res);
            });
        } else {
          //console.log(formSchema.asset_status);
          commonService
            .insertFormData(this.formSchema, "asset_master")
            .then(res => {
              res.action = "add";
              this.close(res);
            });
        }
      }
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
      this.changeAssetCodeField();
    },

    loadData() {
      this.show = true;
    },

    setPackageCode() {
      // onchange Package no to
      var package_no = this.formSchema.package_no;
      var index = this.assetPackage
        .map(function(e) {
          return e.id;
        })
        .indexOf(package_no);
      var package_code = this.assetPackage[index].name;
      this.formSchema.package_code = package_code;
    },
    // Change and set Asset Code=======
    changeAssetCodeField() {
      // Asset Name List
      this.formSchema.asset_code ='';
      var item_id = this.formSchema.item_id;
      var purchase_date = this.formSchema.purchase_date;
      
      //this.formSchema.asset_code = "";
      var asset_name = this.formSchema.item_id;
      var index = this.assetNames
        .map(function(e) {
          return e.id;
        })
        .indexOf(asset_name);

      var queryData = {'item_id': this.assetNames[index].item_name , 'p_date':purchase_date};
      commonService
        .getServerSideData(queryData,"get_asset_new_code")
        .then(res => {
          let assetCode = res.asset_code;
          if(!this.formSchema.id > 0){
            type == 1 ? (this.formSchema.asset_code = assetCode) : (this.formSchema.asset_code = 'N/A');
          }
        });

      //var code = this.assetCode.substr(0, 5) + 'AMI/' + this.assetCode.substr(5);  
      var type = this.assetNames[index].is_fixed_asset;
      this.formSchema.is_fixed_asset = this.assetNames[index].is_fixed_asset;
      this.formSchema.unit_id = this.assetNames[index].unit_id;
      this.formSchema.unit_name = this.assetNames[index].unit_name;
    },

    // close: function Perform
    close: function(data) {
      if (data.status == 1) {
        let formSchema = this.formSchema;
        formSchema.purchase_date =''
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/asset/asset_master/asset_master_form.vue